/**
 * Eigene, "use client"-freie Datei fuer diese eine Konstante (Landingpage-Feedback
 * Runde 5, 2026-08-18, Punkt 1) - urspruenglich in feature-snippets.tsx ("use client")
 * exportiert, aber ein einfacher String-Export aus einer "use client"-Datei kommt in
 * einer Server Component, die ihn importiert (app/page.tsx -> HomePage), nicht
 * zuverlaessig an (React Server Components ersetzen den Modul-Export ueber die
 * Client-Grenze durch eine Referenz, die fuer normale Konstanten nicht wie ein
 * gewoehnliches ESM-Binding funktioniert - live bestaetigt: `cn()` erhielt dort
 * `undefined` statt des Strings, obwohl derselbe Import in feature-snippets.tsx selbst
 * korrekt funktionierte). Eine reine, direktivenlose `.ts`-Datei kann dagegen
 * problemlos von Server- UND Client-Komponenten importiert werden.
 */
export const SNIPPET_CAPTION_CLASSES = "font-serif text-xl sm:text-2xl";
